module.exports = __webpack_public_path__ + "img/yellow-porsche-01.5a655ae8.jpg";